import { configureStore } from "@reduxjs/toolkit";
import { appReducer } from "app";
import { AuthApi, EgerdauApi, QuickQuoteApi } from "common/services";

export const appStore = configureStore({
  reducer: {
    app: appReducer,
    [QuickQuoteApi.reducerPath]: QuickQuoteApi.reducer,
    [EgerdauApi.reducerPath]: EgerdauApi.reducer,
    [AuthApi.reducerPath]: AuthApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      QuickQuoteApi.middleware,
      EgerdauApi.middleware,
      AuthApi.middleware,
    ]),
});

export type RootState = ReturnType<typeof appStore.getState>;
export type AppDispatch = typeof appStore.dispatch;
